import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FaTachometerAlt, FaMoneyCheckAlt, FaDonate, FaClock } from "react-icons/fa";

// Card data object
const cardData = [
  {
    id: 1,
    icon: <FaTachometerAlt size={40} />,
    bgColor: "bg-blue-100",
    textColor: "text-blue-600",
    title: "Access a personalized dashboard",
    delay: 0.2,
  },
  {
    id: 2,
    icon: <FaMoneyCheckAlt size={40} />,
    bgColor: "bg-green-100",
    textColor: "text-green-600",
    title: "Withdraw your funds faster",
    delay: 0.4,
  },
  {
    id: 3,
    icon: <FaDonate size={40} />,
    bgColor: "bg-yellow-100",
    textColor: "text-yellow-600",
    title: "Keep track of all your donations received",
    delay: 0.6,
  },
  {
    id: 4,
    icon: <FaClock size={40} />,
    bgColor: "bg-purple-100",
    textColor: "text-purple-600",
    title: "Start fundraisers within seconds",
    delay: 0.8,
  },
];

// Variants for animation
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },

};

const ManageFundraiser = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true });

  return (
    <motion.div
      className="min-h-auto bg-gray-50 flex flex-col items-center justify-center p-8"
      ref={sectionRef}
    >
      {/* Heading */}
      <motion.h1
        className="text-4xl font-bold text-center mb-10 text-gray-800"
        initial={{ opacity: 0, y: -50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1.5 }}
      >
        Manage your fundraisers on the go
      </motion.h1>

      {/* Features Section */}
      <motion.ul
        className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 w-full max-w-6xl cursor-pointer"
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={cardVariants}
      >
        {cardData.map((card) => (
          <motion.li
            key={card.id}
            className="bg-white p-10 shadow-lg rounded-lg text-center flex flex-col items-center "
            variants={cardVariants}
            transition={{ delay: card.delay }}
          >
            <div
              className={`w-20 h-20 flex items-center justify-center ${card.bgColor} ${card.textColor} rounded-full mb-6`}
            >
              {card.icon}
            </div>
            <p className="font-semibold text-gray-800">{card.title}</p>
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>
  );
};

export default ManageFundraiser;
